module.exports = __webpack_public_path__ + "static/img/img-1.287affe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/img-1.png
// module id = 1P+r
// module chunks = 63